import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

const LoadingScreen = props => {
  return (
    <Box>
      <Stack
        direction='row'
        justifyContent='center'
        padding={6}
      >
        <CircularProgress />
      </Stack>
    </Box>
  );
};

export default LoadingScreen;
